export default __webpack_public_path__ + "assets/ico_contract-81e51057.svg";